import axios from "axios";
import photoService from "services/photoService";
import config from 'config';

import {
  GET_LIST,
  SET_UPLOAD_PROGRESS,
  UPDATE_PHOTO_SOURCE,
  ADD_PHOTO,
  RENAME_PHOTO,
  DELETE_PHOTO,
  SET_LOADER
} from "./photosActionTypes";

const photosActions = (dispatch) => {
  const fetchList = async (sessionId) => {
    let photoList = await _fetchList(sessionId);
    dispatch({
      type: GET_LIST,
      payload: photoList
    });
  };

  const setUploadProgress = (photoId, progress) => {
    dispatch({
      type: SET_UPLOAD_PROGRESS,
      payload: { photoId, progress }
    })
  }

  const updatePhotoSource = (photoId, filePath) => {
    dispatch({
      type: UPDATE_PHOTO_SOURCE,
      payload: { photoId, filePath }
    })
  }

  const addPhoto = (imageObject) => {
    dispatch({
      type: ADD_PHOTO,
      payload:  imageObject
    })
  }

  const renamePhoto = async (imageObject, newName, sessionId, loaderType) => {
    dispatch({
      type: SET_LOADER,
      payload: {loader: loaderType, fileName: imageObject.fileName}
    });
    await photoService.renamePhoto(imageObject.fileName, newName, sessionId);
    dispatch({
      type: RENAME_PHOTO,
      payload: {newName, photoId: imageObject.id }
    });
  }

  const deletePhoto = async (fileName, sessionId) => {
    dispatch({
      type: SET_LOADER,
      payload: {loader: "delete", fileName}
    });
    await _deletePhoto(fileName, sessionId);
    dispatch({
      type: DELETE_PHOTO,
      payload: fileName
    })
  }

  return { fetchList, 
    setUploadProgress, 
    updatePhotoSource, 
    addPhoto, 
    renamePhoto,
    deletePhoto };
};

const _deletePhoto = (fileName, sessionId) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Photo?fileName=${fileName}&sessionId=${sessionId}`,
      method: "DELETE"
    }).then((response) => {
      resolve(response.data);
    }).catch((response) => {
      console.log("Error getting logs", response);
      reject();
    });
  });

}

const _fetchList = (sessionId) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${config.url}/api/Photo/List?sessionId=${sessionId}`,
      method: "GET"
    }).then((response) => {
      resolve(response.data);
    }).catch((response) => {
      console.log("Error getting logs", response);
      reject();
    });
  });
}

export default photosActions;